<script>
	import { onMount } from 'svelte';
	import Nav from '../components/Nav.svelte';
	import Slide from '../components/Slide.svelte';
	// import { darkTheme } from '../components/stores.js';
	import {sidebar } from '../store.js';

	export let segment;

	// close left sidemenu when click on left side menu item
	onMount(() => {
		let smenu = document.getElementsByClassName('smenu');
		let chBox = document.getElementById('nav-trigger');
		for (let i=0; i<smenu.length; i++) {
			smenu[i].addEventListener("click", function(){
				chBox.checked = 0;
			})
		}

	
	});
	
</script>


	<ul class="navigation md:hidden">
		{#each $sidebar.items as {path, title, comp}}
			<li class="nav-item"><a class="smenu" href="/{path}">{title}</a></li>
		{/each}
	</ul>

	<!--<input type="checkbox" id="nav-trigger" class="nav-trigger md:hidden" />-->
	<input type="checkbox" id="nav-trigger" class="nav-trigger md:hidden" />
	<label id="nav-trigger-label" for="nav-trigger" class="md:hidden">
	<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' x='0px' y='0px' width='30px' height='30px' viewBox='0 0 30 30' enable-background='new 0 0 30 30' xml:space='preserve'><rect width='30' height='6'/><rect y='24' width='30' height='6'/><rect y='12' width='30' height='6'/></svg>
	</label>

	<div id="page" class="page flex-grow-1 md:mt-10 flex flex-col bg-white border border-gray-900 pb-6 md:flex-800 lg:flex-1195 w-full">
		<div class="flex w-full">
			<Nav {segment}/>
		</div>
		<div class="flex flex-row flex-wrap justify-center">
			<slot></slot>
		</div>
	</div>



<style>
	.page {
		box-shadow: 0 4px 6px #333;
	}

	@screen sm_menu {
		.page {
			/* Critical position and size styles */
			min-height: 100%;
			min-width: 100%;
			background-color: white; /* Needs a background or else the nav will show through */
			position: relative;
			top: 0;
			bottom: 100%;
			left: 0;
			z-index: 1;
			height: 100%;
			display: flex;
			flex-direction: column;
			flex-grow: 1;
		}

	/* Navigation Menu - Background */
	.navigation {
	/* critical sizing and position styles */
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 0;
	
	/* non-critical appearance styles */
	list-style: none;
	background: #111;
	}

	/* Navigation Menu - List items */
	.nav-item {
	/* non-critical appearance styles */
	width: 200px;
	border-top: 1px solid #111;
	border-bottom: 1px solid #000;
	}

	.nav-item a {
	/* non-critical appearance styles */
	display: block;
	padding: 1em;
	background: linear-gradient(135deg, rgba(0,0,0,0) 0%,rgba(0,0,0,0.65) 100%);
	color: white;
	font-size: 1.2em;
	text-decoration: none;
	transition: color 0.2s, background 0.5s;
	}

	.nav-item a:hover {
	color: #c74438;
	background: linear-gradient(135deg, rgba(0,0,0,0) 0%,rgba(75,20,20,0.65) 100%);
	}


	}


		/* Nav Trigger */
	.nav-trigger {
	/* critical styles - hide the checkbox input */
	position: absolute;
	clip: rect(0,0,0,0);
	}

	svg rect {
		fill: white;
	}

	label[for="nav-trigger"] {
	/* critical positioning styles */
	position: fixed;
	left: 15px; top: 15px;
	z-index: 2;
	
	/* non-critical apperance styles */
	height: 30px;
	width: 30px;
	cursor: pointer;
	}

	/* Make the Magic Happen */
	.nav-trigger + label, .page {
	transition: left 0.2s;
	}

	.nav-trigger:checked + label {
	left: 215px;
	}

	.nav-trigger:checked ~ .page {
	left: 200px;
	box-shadow: 0 0 5px 5px rgba(0,0,0,0.5);
	}


</style>